var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Lista de CESTs")])]),_c('v-data-table',{attrs:{"id":"tableCEST","headers":_vm.header,"items":_vm.items},on:{"click:row":_vm.selectCEST}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }